import axios from "axios";
import query from "./constants.api";

// const config : AxiosRequestConfig = {baseURL: 'https://jsonplaceholder.typicode.com'}
// export const axiosInstance = axios.create(config);

const axiosInstance = (method, url, params, type, baseUrl, body) => {
    const contentType = type ? type : 'application/x-www-form-urlencoded';

    // const accessToken = 'Bearer ' + localStorage.getItem('adeporto_token');
    const headers = {
        'content-type': contentType,
        Authorization: localStorage.getItem(`adeporto_token`),
    };

    let config = {
        method: method ? method : 'GET',
        baseURL: baseUrl ? baseUrl : query.baseURL,
        url: url ? url : '',
        headers: headers,
        data: body,
        params: params,
    };

    return axios(config);
};

export default axiosInstance;